import ActionTypes from "../../../../constants/ActionTypes";
import { IFetchContractsAction, IGetContractsAction, ISetContractInSessionStorage, ISetContractsAction } from "./types";

export function fetchContractsAction(): IFetchContractsAction {
  return {
    type: ActionTypes.CONTRACT.MANHATTAN.FETCH_CONTRACTS,
  };
}

export function getContractsAction(): IGetContractsAction {
  return {
    type: ActionTypes.CONTRACT.MANHATTAN.GET_CONTRACTS,
  };
}

export function setContractsAction(contracts: object): ISetContractsAction {
  return {
    type: ActionTypes.CONTRACT.MANHATTAN.SET_CONTRACTS,
    payload: contracts,
  };
}

export function setContractInSessionStorage(data: any): ISetContractInSessionStorage {
  return {
    type: ActionTypes.CONTRACT.MANHATTAN.SET_CONTRACT_IN_SESSION_STORAGE,
    payload: {
      data
    },
  };
}
